import type { FC } from 'react'

import { AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import H2 from '@/components/H2'
import useUser from '@/hooks/useUser'
import type { Application } from '@/types/Activity'
import { Role } from '@/types/User'
import { hasRole } from '@/utils/role'

import ResetSections from './ResetSections'

interface Props {
  application: Application
  customerId: string
  applicationId: string
  subjectId: string
  onClose: () => void
}

const ResetSectionsPanel: FC<Props> = ({
  application,
  customerId,
  applicationId,
  subjectId,
  onClose,
}) => {
  const { roles } = useUser()
  const showResetWholeSubject = hasRole(roles, [Role.supervisor, Role.admin])

  return (
    <SlideInSidebar
      onClose={onClose}
      header={<H2>Reset Sections</H2>}
      content={
        <ResetSections
          application={application}
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          showResetWholeSubject={showResetWholeSubject}
        />
      }
      footer={
        <div className="side-by-side-flex-end">
          <AlternateButton onClick={onClose}>Cancel</AlternateButton>
        </div>
      }
    />
  )
}

export default ResetSectionsPanel
